/* eslint-disable */

export enum UpgradeStatus {
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  COMPLETE = "COMPLETE",
}

export interface UiTaxUpgrade {
  customer_token?: string;
  upgrade_status?: UpgradeStatus;
}
